<div class="modal__content ageverify">
    <div v-if="!approve" class="ageverify__wrapper">
        <div class="ageverify__status" :class="statusMessage.class">
            <p>{{ $t('modals.ageverify.notstoredimages') }}</p>
        </div>
        <div class="form__group">
            <a class="btn btn-black" @click="closeModal('ageverify')">{{ $t('modals.ageverify.denied') }}</a>
            <a class="btn" @click="load()">{{ $t('modals.ageverify.approve') }}</a>
        </div>
    </div>
    <div class="ageverify__wrapper" v-else>
        <div class="ageverify__status" :class="statusMessage.class">
            <p>{{ $t('modals.ageverify.' + statusMessage.msg) }}</p>
        </div>
        <div class="ageverify__guide">
            <div class="ageverify__guide-video">
                <video id="selfie_video" ref="video" width="640" height="480" autoplay muted playsinline :poster="`data:image/jpeg;base64,${imageBase64}`"></video>
            </div>
            <div class="ageverify__guide-placeholder" ref="placeholder">
                <img src="../../../assets/images/guide-selfie.svg" alt="selfie placeholder" />
            </div>
            <canvas class="ageverify__guide-canvasDetector" v-show="detectorShow" ref="detectorCanvas"></canvas>
        </div>
    </div>
</div>